module.exports = __webpack_public_path__ + "static/img/137_TO8_1834.0b62c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/137_TO8_1834.jpg
// module id = T4pT
// module chunks = 0